/* eslint-disable max-len */

// Иконка архива в меню
export const ArchiveIcon = () => {
  const renderContent = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M11.6875 1.43771L16.0625 5.81271C16.186 5.92412 16.2545 6.08397 16.25 6.25021V17.5002C16.25 18.1906 15.6904 18.7502 15 18.7502H5C4.30964 18.7502 3.75 18.1906 3.75 17.5002V2.50021C3.75 1.80985 4.30964 1.25021 5 1.25021H11.25C11.4162 1.24574 11.5761 1.31425 11.6875 1.43771ZM6.87 10H13.12V11.25H6.87V10ZM6.87 13.75H13.12V15H6.87V13.75ZM11.25 2.75021L14.75 6.25021H11.25V2.75021ZM5 17.5002H15V7.50021H11.25C10.5596 7.50021 10 6.94056 10 6.25021V2.50021H5V17.5002Z' fill='currentColor' />
    </svg>
  );

  return renderContent();
};
